<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string
    content: string
    titleTag?: 'p' | 'h2' | 'h3'
  }>(),
  {
    titleTag: `h2`,
  },
);

defineSlots<{
  icon: () => unknown
}>();
</script>

<template>
  <details class="group border-b border-neutral-60 group-[.is-prestige]:border-neutral-70/20">
    <summary class="marker:hidden flex justify-between items-center py-l cursor-pointer">
      <div class="flex gap-l items-center flex-1">
        <slot name="icon" />
        <IadTitle
          :tag="titleTag"
          variant="x-small"
          :text="title"
        />
      </div>
      <IadBtn
        size="small"
        variant="outlined"
        class="pointer-events-none"
        icon
      >
        <Icon
          name="iad-icon:caret-down"
          class="group-open:rotate-180"
        />
      </IadBtn>
    </summary>
    <p
      class="pb-l whitespace-pre-line"
      v-text="content"
    />
  </details>
</template>
